
import { Dispatch, SetStateAction, useEffect } from 'react';
import { KaziModal } from './Kazi/KaziModal';
import { useMobileView } from '../Hooks/useMobileView';
import { AppSettings } from '../Utils/Settings';

interface KaziDemoModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export const KaziDemoModal = ({open, setOpen}:KaziDemoModalProps ) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false)
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            sx={{width: 'fit-content', height: 'fit-content', overflowY: 'auto'}}
            handleClose={handleClose}
            title=''
            content={<><iframe className="demoVideo" src={AppSettings.KaziDemoUrl} width="979" height="548" allow="autoplay" allowFullScreen></iframe></>}
            actions={[]}
        />
    )
}